import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Modal, message, Table, Radio, notification } from 'antd';
import { getUsers, getRefreshTokin, changeUsersRole, deleteUser } from '../api/api';
import './AdminUsers.css';

const AdminUsers = () => {
  const [banksUpdate, setBanksUpdate] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const [idUser, setIdUser] = useState(false);
  const [userData, setUserData] = useState([]);
  const key = 'updatable';

  const optionsClick = (e: any) => {
    changeUsersRole(e.target.name, e.target.value).then((res) => {
      if (res[0] === 'error') {
        message.error({ content: res[1], key, duration: 3 });
      } else message.success({ content: res, key, duration: 1 });
    });
  };

  const catchError = () => {
    getRefreshTokin()
      .then((res: any) => res.json())
      .then((res) => {
        localStorage.access_token = res.access_token;
        getUsers().then((res) => {
          setUserData(res);
          message.loading({ content: 'Загрузка...', key });
        });
      })
      .catch(() => {
        localStorage.removeItem('access_token');
        window.location.reload();
      });
  };
  const getUsersFunc = () => {
    getUsers()
      .then((res: any) => {
        //constructTable(res)
        if (res.message) {
          catchError();
        } else {
          setUserData(res);
          message.success({ content: 'Готово!', key, duration: 2 });
        }
      })
      .catch(catchError);
  };
  const userDeleteFunc = (e: any) => {
    setIdUser(e);
    setIsModalDeleteVisible(true);
  };

  useEffect(() => {
    getUsersFunc();
  }, [banksUpdate]);

  //colums
  const columns = [
    {
      title: 'Имя',
      dataIndex: 'name',
      key: 'name',
      render: (text: any) => <a>{text}</a>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Выберите роль',
      key: 'action',
      render: (text: any, record: any) => (
        <>
          {localStorage.role !== '93260' ? (
            record.roleId === 93160 || record.roleId === 93260 ? (
              record.roleName
            ) : (
              <Radio.Group
                defaultValue={record.roleId}
                name={record.key}
                buttonStyle="solid"
                onChange={optionsClick}
              >
                <Radio.Button value={67270}>Без прав</Radio.Button>
                <Radio.Button value={67274}>Руководитель</Radio.Button>
                <Radio.Button value={76399}>Пользователь</Radio.Button>
              </Radio.Group>
            )
          ) : (
            <Radio.Group
              defaultValue={record.roleId}
              name={record.key}
              buttonStyle="solid"
              onChange={optionsClick}
            >
              <Radio.Button value={67270}>Без прав</Radio.Button>
              <Radio.Button value={67274}>Руководитель</Radio.Button>
              <Radio.Button value={76399}>Пользователь</Radio.Button>
              <Radio.Button value={93160}>Админ</Radio.Button>
            </Radio.Group>
          )}
        </>
      ),
    },
    {
      title: 'Удалить',
      key: 'delete',
      render: (text: any, record: any) => (
        <>
          {localStorage.role !== '93260' ? (
            record.roleId === 93160 || record.roleId === 93260 ? null : (
              <button
                id={record.key}
                name={'userName' + record.key}
                onClick={() => {
                  userDeleteFunc(record.key);
                }}
                className="item__user-delete-button"
              >
                <div>X</div>
              </button>
            )
          ) : (
            <button
              id={record.key}
              name={'userName' + record.key}
              onClick={() => {
                userDeleteFunc(record.key);
              }}
              className="item__user-delete-button"
            >
              <div>X</div>
            </button>
          )}
        </>
      ),
    },
  ];

  const handleOkDelete = () => {
    deleteUser(idUser)
      .then((res) => {
        if (res[0] === 'error') message.error({ content: res[1], key, duration: 1 });
        else if (res === 'Пользователь успешно удален!') {
          notification.open({ message: res });
          if (banksUpdate) setBanksUpdate(false);
          else setBanksUpdate(true);
        } else message.error({ content: 'Что-то пошло не так', key, duration: 1 });
      })
      .catch((res) => message.error({ content: 'Что-то пошло не так', key, duration: 1 }));
    setIsModalDeleteVisible(false);
  };
  const handleCancelDelete = () => {
    setIsModalDeleteVisible(false);
  };
  return (
    <>
      <Table columns={columns} dataSource={userData} />

      <Modal
        key={idUser + 'D'}
        title="Форма удаления"
        open={isModalDeleteVisible}
        onOk={handleOkDelete}
        onCancel={handleCancelDelete}
      >
        <h3>Вы уверены?</h3>
      </Modal>
    </>
  );
};

export default AdminUsers;
